import { ReactNode } from 'react'
import { Link } from 'react-router'
import {
  ListItemButton,
  Typography,
  Stack,
  alpha,
  useTheme,
} from '@mui/material'
import { SUPER_USER_ONLY_COLOR } from '@/theme/usePixydocsTheme'

type TopBarNavigationItemProps = {
  label: string
  to: string
  icon?: ReactNode
  isSuperUserOnly?: boolean
  selected: boolean
  keepQueryParams?: boolean
}

export default function HorizontalTab({
  label,
  to,
  icon,
  isSuperUserOnly,
  selected,
  keepQueryParams = false,
}: TopBarNavigationItemProps) {
  const theme = useTheme()

  const accentColor = isSuperUserOnly
    ? SUPER_USER_ONLY_COLOR
    : theme.palette.primary.main
  const color = selected ? accentColor : 'text.secondary'

  return (
    <ListItemButton
      component={Link}
      to={`${to}?${
        keepQueryParams ? new URLSearchParams(window.location.search) : ''
      }`}
      sx={{
        position: 'relative',
        borderRadius: 2,
        py: 0.75,
        px: 1,
        color,
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        backgroundColor: selected ? alpha(accentColor, 0.08) : 'transparent',
        '&:hover': {
          backgroundColor: selected
            ? alpha(accentColor, 0.12)
            : alpha(theme.palette.text.primary, 0.04),
        },
        '&:visited': {
          textDecoration: 'none',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: selected ? '12px' : '50%',
          width: selected ? 'calc(100% - 24px)' : 0,
          height: 2,
          borderRadius: 1,
          backgroundColor: accentColor,
          transition: 'all 0.2s ease',
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={0.75}>
        {icon}
        <Typography
          variant="body2"
          fontWeight={600}
          sx={{ transition: 'font-weight 0.2s ease' }}
        >
          {label}
        </Typography>
      </Stack>
    </ListItemButton>
  )
}
